import Phaser from 'phaser';

import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { CardViewModel } from './card-view-model';

export class CardBackView extends Phaser.GameObjects.Container {
  private viewModel: CardViewModel;
  private cardBack: Phaser.GameObjects.Image;

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: CardViewModel) {
    super(scene, x, y);

    this.viewModel = viewModel;

    this.cardBack = scene.add.image(0, 0, viewModel.cardBackAsset.type).setOrigin(0.5, 0.5);

    this.add([this.cardBack]);
    this.setName(CardBackView.name);
    scene.add.existing(this);
  }

  public onResize(scaleFactor: number): void {
    this.resizeCard(scaleFactor);
  }

  private resizeCard(scaleFactor: number) {
    const asset = this.viewModel.cardBackAsset;
    this.cardBack.setDisplaySize(
      asset.dimensions.width * scaleFactor,
      asset.dimensions.height * scaleFactor,
    );
  }
}
